import { type AxiosError } from 'axios'
import { type UseQueryOptions } from 'react-query'

import { useGetStatusChecks } from 'queries/status-checks/use-get-status-checks'
import { formatExistingStatusCheck } from 'utils/team-external-integrations/team-external-integrations-util'

import type {
  ServiceStatusCheckFromStatusCheck,
  StatusCheck
} from 'types/api/status-checks/status-check'

function selectorFn(data: StatusCheck[]) {
  return data.map(formatExistingStatusCheck)
}

export function useGetStatusChecksAsServiceStatusChecks(
  options?: UseQueryOptions<
    StatusCheck[],
    AxiosError,
    ServiceStatusCheckFromStatusCheck[]
  >
) {
  return useGetStatusChecks<ServiceStatusCheckFromStatusCheck[]>({
    ...options,
    select: selectorFn
  })
}
